export const purchaseColumns = [
  { field: "name", headerName: "Item", width: 240 },
  { field: "type", headerName: "Type", width: 127 },
  { field: "quantity", headerName: "Quantity", width: 113 },
  { field: "paymentID", headerName: "Payment ID", width: 157 },
  { field: "date", headerName: "Date", width: 157 },
  { field: "orderAmount", headerName: "Order amount", width: 157 }
];
